__turbopack_context__.v({
  "btnWrp": "styles-module__x4heeW__btnWrp",
  "footer": "styles-module__x4heeW__footer",
  "footerContent": "styles-module__x4heeW__footerContent",
  "footerLink": "styles-module__x4heeW__footerLink",
  "footerLinks": "styles-module__x4heeW__footerLinks",
  "footerWrap": "styles-module__x4heeW__footerWrap",
});
